import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import RoughFilters from "@/components/RoughFilters";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import ProjectDetail from "@/pages/ProjectDetail";
import Resume from "@/pages/Resume";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminPlanning from "@/pages/admin/AdminPlanning";
import AdminLayout from "@/components/admin/AdminLayout";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <Toaster position="top-center" theme="dark" />
      <BrowserRouter>
        <Routes>
          {/* admin routes — no Navbar/Footer */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="planning" element={<AdminPlanning />} />
            <Route path="planning/:slug" element={<AdminPlanning />} />
          </Route>

          {/* public routes */}
          <Route
            path="/*"
            element={
              <LanguageProvider>
                <RoughFilters />
                <Navbar />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/projects/:slug" element={<ProjectDetail />} />
                  <Route path="/resume" element={<Resume />} />
                </Routes>
                <Footer />
              </LanguageProvider>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
